/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
  ADD_TEAM_SCHEDULING,
  ADD_TEAM_SCHEDULING_SUCCESS,
  ADD_TEAM_SCHEDULING_ERROR,
  LOAD_TEAM_SCHEDULING_SERVICE,
  LOAD_TEAM_SCHEDULING_SERVICE_SUCCESS,
  LOAD_TEAM_SCHEDULING_SERVICE_ERROR,
  UPDATE_TEAM_SCHEDULING_SERVICE,
  UPDATE_TEAM_SCHEDULING_SERVICE_SUCCESS,
  UPDATE_TEAM_SCHEDULING_SERVICE_ERROR,

  
  UPDATE_TEAM_SCHEDULING,
  UPDATE_TEAM_SCHEDULING_SUCCESS,
  UPDATE_TEAM_SCHEDULING_ERROR,

  SHOOTER_HISTORY_LIST,
  SHOOTER_HISTORY_LIST_SUCCESS,
  SHOOTER_HISTORY_LIST_ERROR,
  TEAM_FINAL_COMMIT,
  TEAM_FINAL_COMMIT_SUCCESS,
  TEAM_FINAL_COMMIT_ERROR,
 
  LOAD_TEAM_SCHEDULING,
  LOAD_TEAM_SCHEDULING_SUCCESS,
  LOAD_TEAM_SCHEDULING_ERROR,
  LOAD_EVENT_TEAM_SCHEDULING,
  LOAD_EVENT_TEAM_SCHEDULING_SUCCESS,
  LOAD_EVENT_TEAM_SCHEDULING_ERROR,

  AGENT_VANCANY_LIST,
  AGENT_VANCANY_LIST_SUCCESS,
  AGENT_VANCANY_LIST_ERROR,

  AGENT_OFFICE_VACANCY_LIST,
  AGENT_OFFICE_VACANCY_LIST_SUCCESS,
  AGENT_OFFICE_VACANCY_LIST_ERROR,

   LOAD_FREELANCER_LIST,
  LOAD_FREELANCER_LIST_SUCCESS,
  LOAD_FREELANCER_LIST_ERROR,
  REMOVE_TEAM_SERVICE,
  REMOVE_TEAM_SERVICE_SUCCESS,
  REMOVE_TEAM_SERVICE_ERROR,
} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


export function loadTeamSchedling(id) {
  return {
    type: LOAD_TEAM_SCHEDULING,
    id,
  }
}

export function loadTeamSchedlingSuccess(team_scheduling_details) {
  return {
    type: LOAD_TEAM_SCHEDULING_SUCCESS,
    team_scheduling_details,
  }
}

/**
 * @param {string} error
 */

export function loadTeamSchedlingError(error) {
  return {
    type: LOAD_TEAM_SCHEDULING_ERROR,
    error,
  }
}
export function loadTeamSchedlingService(record) {
  return {
    type: LOAD_TEAM_SCHEDULING_SERVICE,
    record,
  }
}

export function loadTeamSchedlingServiceSuccess(team_scheduling_services) {
  return {
    type: LOAD_TEAM_SCHEDULING_SERVICE_SUCCESS,
    team_scheduling_services,
  }
}

/**
 * @param {string} error
 */

export function loadTeamSchedlingServiceError(error) {
  return {
    type: LOAD_TEAM_SCHEDULING_SERVICE_ERROR,
    error,
  }
}
export function loadFreelancerList(record) {
  return {
    type: LOAD_FREELANCER_LIST,
    record
  }
}

export function loadFreelancerListSuccess(freelancer_details) {
  return {
    type: LOAD_FREELANCER_LIST_SUCCESS,
    freelancer_details,
  }
}

/**
 * @param {string} error
 */

export function loadFreelancerListError(error) {
  return {
    type: LOAD_FREELANCER_LIST_ERROR,
    error,
  }
}

export function loadEventTeamSchedling(eventScheduling) {
  return {
    type: LOAD_EVENT_TEAM_SCHEDULING,
    eventScheduling,
  }
}

export function loadEventTeamSchedlingSuccess(event_team_scheduling) {
  return {
    type: LOAD_EVENT_TEAM_SCHEDULING_SUCCESS,
    event_team_scheduling,
  }
}

/**
 * @param {string} error
 */

export function loadEventTeamSchedlingError(error) {
  return {
    type: LOAD_EVENT_TEAM_SCHEDULING_ERROR,
    error,
  }
}

export function addTeamScheduling(teamScheduling) {
  console.log("record", teamScheduling)
  return {
    type: ADD_TEAM_SCHEDULING,
    teamScheduling,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addTeamSchedulingSuccess(teamScheduling, success) {
  console.log("record", teamScheduling)
  return {
    type: ADD_TEAM_SCHEDULING_SUCCESS,
    teamScheduling,
    success,
  }
}

/**
 * @param {string} error
 */
export function addTeamSchedulingError(error) {
  return {
    type: ADD_TEAM_SCHEDULING_ERROR,
    error,
  }
}

//Update team scheduling
export function updateTeamSchedulingService(teamScheduling) {
  console.log("record", teamScheduling)
  return {
    type: UPDATE_TEAM_SCHEDULING_SERVICE,
    teamScheduling,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateTeamSchedulingServiceSuccess(teamScheduling, success) {
  console.log("record", teamScheduling)
  return {
    type: UPDATE_TEAM_SCHEDULING_SERVICE_SUCCESS,
    teamScheduling,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateTeamSchedulingServiceError(error) {
  return {
    type: UPDATE_TEAM_SCHEDULING_SERVICE_ERROR,
    error,
  }
}
//Update team scheduling
export function removeTeamSchedulingService(teamScheduling) {
  console.log("record", teamScheduling)
  return {
    type: REMOVE_TEAM_SERVICE,
    teamScheduling,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function removeTeamSchedulingServiceSuccess(teamScheduling, success) {
  console.log("record", teamScheduling)
  return {
    type: REMOVE_TEAM_SERVICE_SUCCESS,
    teamScheduling,
    success,
  }
}

/**
 * @param {string} error
 */
export function removeTeamSchedulingServiceError(error) {
  return {
    type: REMOVE_TEAM_SERVICE_ERROR,
    error,
  }
}

//Update team scheduling
export function updateTeamScheduling(teamScheduling) {
  console.log("record", teamScheduling)
  return {
    type: UPDATE_TEAM_SCHEDULING,
    teamScheduling,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateTeamSchedulingSuccess(teamScheduling, success) {
  console.log("record", teamScheduling)
  return {
    type: UPDATE_TEAM_SCHEDULING_SUCCESS,
    teamScheduling,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateTeamSchedulingError(error) {
  return {
    type: UPDATE_TEAM_SCHEDULING_ERROR,
    error,
  }
}

//Final Commit
export function teamFinalCommit(finalCommit) {
  console.log("record", finalCommit)
  return {
    type: TEAM_FINAL_COMMIT,
    finalCommit,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function teamFinalCommitSuccess(finalCommit, success) {
  console.log("record", finalCommit)
  return {
    type: TEAM_FINAL_COMMIT_SUCCESS,
    finalCommit,
    success,
  }
}

/**
 * @param {string} error
 */
export function teamFinalCommitError(error) {
  return {
    type: TEAM_FINAL_COMMIT_ERROR,
    error,
  }
}

//Shooter History

export function loadShooterHistory(empId) {
  return {
    type: SHOOTER_HISTORY_LIST,
    empId,
  }
}

export function loadShooterHistorySuccess(shooter_history) {
  return {
    type: SHOOTER_HISTORY_LIST_SUCCESS,
    shooter_history,
  }
}

/**
 * @param {string} error
 */

export function loadShooterHistoryError(error) {
  return {
    type: SHOOTER_HISTORY_LIST_ERROR,
    error,
  }
}

export function loadAgentVacancy(record) {
  return {
    type: AGENT_VANCANY_LIST,
    record,
  }
}

export function loadAgentVacancySuccess(agent_vacancy_details) {
  return {
    type: AGENT_VANCANY_LIST_SUCCESS,
    agent_vacancy_details,
  }
}

/**
 * @param {string} error
 */

export function loadAgentVacancyError(error) {
  return {
    type: AGENT_VANCANY_LIST_ERROR,
    error,
  }
}

export function loadAgentOfficeVacancy(record) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST,
    record,
  }
}

export function loadAgentOfficeVacancySuccess(agent_office_details) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST_SUCCESS,
    agent_office_details,
  }
}

/**
 * @param {string} error
 */

export function loadAgentOfficeVacancyError(error) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST_ERROR,
    error,
  }
}

const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  
  loadTeamSchedling,
  loadTeamSchedlingSuccess,
  loadTeamSchedlingError,

  addTeamScheduling,
  addTeamSchedulingError,
  addTeamSchedulingSuccess,

  loadTeamSchedlingService,
  loadTeamSchedlingServiceSuccess,
  loadTeamSchedlingServiceError,

  updateTeamSchedulingService,
  updateTeamSchedulingServiceError,
  updateTeamSchedulingServiceSuccess,
  loadEventTeamSchedling,
  loadEventTeamSchedlingSuccess,
  loadEventTeamSchedlingError,



  updateTeamScheduling,
  updateTeamSchedulingSuccess,
  updateTeamSchedulingError,

  teamFinalCommit,
  teamFinalCommitSuccess,
  teamFinalCommitError,

  loadShooterHistory,
  loadShooterHistorySuccess,
  loadShooterHistoryError,

  loadAgentVacancy,
  loadAgentVacancySuccess,
  loadAgentVacancyError,

  loadAgentOfficeVacancy,
  loadAgentOfficeVacancySuccess,
  loadAgentOfficeVacancyError,
  loadFreelancerList, 
  loadFreelancerListSuccess, 
  loadFreelancerListError, 
  removeTeamSchedulingServiceError,
  removeTeamSchedulingServiceSuccess,
  removeTeamSchedulingService,

}

export default actions
